import React from 'react'
import { Button } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import * as S from './../closeSurvey.styles'

export const CloseSurveySkeleton = () => {
    return (
        <S.CloseSurveyWrapper>
            <S.Details>
                <S.Title>
                    <Skeleton width={80} />
                </S.Title>

                <S.Description>
                    <Skeleton width={120} />
                </S.Description>
            </S.Details>

            <Button color="secondaryLight">
                <Skeleton width={100} />
            </Button>
        </S.CloseSurveyWrapper>
    )
}
